import { Form, Question } from './../../../shared/models/form.model';
import { Component, Inject, Input } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as ReasonsActions from '../reasons.actions';
import * as ReasonFormActions from './reason-form.actions';
import { currentQuestionSelector } from '../../../../main/selectors/reason-form-selectors';
import { AppointmentRequestsService } from '../../../home/appointment-requests/appointment-requests.service';
import { Group } from '../../../shared/models/group.model';
import { Reason } from '../../../shared/models/reason.model';
import { MomentPreferences } from '../../../shared/models/moment-preferences.model';
import { AppointmentRequest } from '../../../shared/models/appointment-request.model';
import { ReasonsService } from '../../../shared/services/reasons.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'reason-form',
  styles: [require('./reason-form.component.scss')],
  template: require('./reason-form.component.html'),
})

export class ReasonFormComponent {
  @Input() reasonFormPromise: Reason;

  public headerDisplayed: boolean = false;
  public appointmentRequestId: number;
  public canDisplayAppointmentPreferences: boolean = false;
  public appointmentPreferences: MomentPreferences = {
    type: 'asap',
    momentOfDay: {
      morning: true,
      afternoon: true,
      evening: true,
    },
    date: moment(),
  };

  ngReduxSubscription;

  loading: boolean;
  selectedPatients: any;

  message: { type: string, text: string, title?: string };

  preferencesMessage: boolean = false;
  preferencesSaving: boolean = false;

  question: Question;
  reasonForm: any;
  reason: Reason;
  group: Group;
  patient: any;
  maxDateOfLastAppointment: moment.Moment;

  isValid: boolean = false;

  currentPatientForm: any;

  model = {
    answer: null,
  };

  private currentSelectedTaskId: number;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
    @Inject('LoadingService') public LoadingService: any,
    @Inject('ProductService') public ProductService: any,
    @Inject('$translate') private $translate,
    private http: HttpClient,
    public AppointmentRequestsService: AppointmentRequestsService,
    public reasonsService: ReasonsService,
  ) { }

  ngOnInit() {
    this.setStateConnection();

    this.$ngRedux.dispatch(new ReasonFormActions.ResetForm());
   
    // If reason doesn't have form, redirect to preferences page
    if (!this.ProductService.isAvailable('PATIENT_FORMS') || !this.reason.form || !this.reason.form.questionsCount) {
      this.$state.go('patients.id.reasons.id.preferences');
    } else {
      this.currentPatientForm = this.selectedPatients.length ? this.selectedPatients[0] : this.patient;

      this.loading = true;
      this.maxDateOfLastAppointment = moment().startOf('day');
      const formId = this.reason.form.id;
      const groupId = this.$ngRedux.getState().group.id;
      this.$ngRedux.dispatch(new ReasonFormActions.ResetForm());
      this.http.get<Form>(`/api/v2/groups/${groupId}/forms/${formId}`)
      .subscribe((form: Form) => {
        this.$ngRedux.dispatch(new ReasonFormActions.SetForm(form));
        this.loading = false;
        this.createEmptyAnswer();
        this.LoadingService.hide();
  
        if (this.reasonForm.form.header) {
          this.headerDisplayed = true;
        }
      });      
    } 
  }

  ngOnDestroy() {
    if (this.ngReduxSubscription) {
      this.ngReduxSubscription();
    }
  }

  setStateConnection() {
    this.ngReduxSubscription = this.$ngRedux.connect(state => ({
      reason: state.reasons.current,
      selectedPatients: state.reasons.selectedPatients,
      reasonForm: state.reasonForm,
      question: currentQuestionSelector(state),
      group: state.group,
      patient: state.currentPatient,
    }))(this);
  }

  next() {
    if (this.headerDisplayed) {
      this.headerDisplayed = false;
      return;
    }

    if (!this.model.answer) {
      return;
    }

    this.extendsAnswer();

    this.$ngRedux.dispatch(new ReasonFormActions.SetAnswer({ [this.currentPatientForm.id]: this.model.answer }));

    let link;
    if (this.question.kind === 'multiple_choice') {
      const choice = this.question.choices.find(chc => (chc.id === +this.model.answer.choiceId));
      if (choice) {
        link = { type: choice.linkType, id: choice.linkId, message: choice.linkMessage };
      } else {
        link = { type: 'next_question', id: null, message: null };
      }
    } else {
      link = { type: this.question.linkType, id: this.question.linkId, message: this.question.linkMessage };
    }

    let nextQuestion;
    let end = false;
    switch (link.type) {
      case 'question':
        nextQuestion = this.reasonForm.form.questions.find(question => (question.id === link.id));
        break;
      case 'next_question':
        // Find next question by display sequence
        nextQuestion = this.reasonForm.form.questions.find(question => (question.displaySequence === (this.question.displaySequence + 1)));
        break;
      case 'message':
        this.message = { type: 'message', text: link.message };
        break;
      case 'appointment':
        
        if (!this.selectedPatients.length) {
          end = true;
        } else {
          const patientIds: number[] = this.selectedPatients.map((patient) => patient.id);
          const patientIndex = patientIds.findIndex((id) => id === this.currentPatientForm.id);

          if (patientIndex === patientIds.length - 1) {
            end = true;
          } else {
            this.currentPatientForm = this.selectedPatients.find((patient) => patient.id === patientIds[patientIndex + 1]);
            nextQuestion = this.reasonForm.form.questions[0];
          }
        }
        
        break;
      case 'appointment_request':
        this.sendAppointmentRequest();
        this.message = {
          type: 'appointmentRequest',
          title: this.$translate.instant('end_message.send_appointment_request_title', { descriptionReason: this.reason.description }),
          text: this.$translate.instant('end_message.send_appointment_request_description'),
        };
        break;
      default:
        break;
    }

    if (!!this.message) { return; }
    
    if (nextQuestion && !end) {
      this.$ngRedux.dispatch(new ReasonFormActions.SetCurrentQuestion(nextQuestion.id));
      this.createEmptyAnswer();
    } else if (this.reasonsService.hasPreferences(this.reason)) {
      this.$state.go('patients.id.reasons.id.preferences');
    } else {
      this.$state.go('patients.id.reasons.id.availabilities');
    }
  }

  findTaskId() {
    const answer: any = _.findLast(this.reasonForm.answers[this.currentPatientForm.id], (aswr: any) => !!aswr.taskId);
    if (answer) {
      return answer.taskId;
    }
    return null;
  }

  sendAppointmentRequest() {
    let params = {
      patientId: this.patient.id,
      reasonId: this.reason.id,
      taskId: this.findTaskId(),
      formAnswer: {
        formId: this.reasonForm.form.id,
        answers: this.reasonForm.answers[Object.keys(this.reasonForm.answers)[0]],  // This is to remove the patientId from the answers data structure
      },
    };

    this.canDisplayAppointmentPreferences = true;

    this.AppointmentRequestsService.post(this.group.id, params)
      .subscribe((appointmentRequest: AppointmentRequest) => {
        this.appointmentRequestId = appointmentRequest.id;
      });
  }

  onDateSet(date: string): void {
    if (date) {
      this.appointmentPreferences.type = 'period';
    }
  }

  getPreferencesMomentsOfDay() {
      const preferences = [];

      if (this.appointmentPreferences.momentOfDay.morning) preferences.push('am');
      if (this.appointmentPreferences.momentOfDay.afternoon) preferences.push('pm');
      if (this.appointmentPreferences.momentOfDay.evening) preferences.push('eve');

      return preferences.length ? preferences : null;
    }

  sendPreferences() {
    let params = {
      momentsOfDay: this.getPreferencesMomentsOfDay(),
      date: (this.appointmentPreferences.date && this.appointmentPreferences.type === 'period')
            ? this.appointmentPreferences.date
            : undefined,
    };

    this.preferencesSaving = true;
    this.AppointmentRequestsService.sendPreferences(this.group.id, this.appointmentRequestId, params)
      .subscribe(() => {
        this.message = null;
        this.preferencesMessage = true;
        this.preferencesSaving = false;
      });
  }

  goToReasonsPage() {
    this.$ngRedux.dispatch(new ReasonsActions.UnsetCurrentReason());
    this.$state.go('patients.id.reasons');
  }

  extendsAnswer() {
    if (this.question.kind === 'date_of_last_appointment') {
      _.assignIn(this.model.answer, { noAvailabilityMessage: this.question.noAvailabilityMessage });
    }

    if (this.question.kind === 'multiple_choice') {
      const choice = this.question.choices.find(chc => (chc.id === +this.model.answer.choiceId));
      if (choice && !!choice.taskId) {
        _.assignIn(this.model.answer, { taskId: choice.taskId });
          this.currentSelectedTaskId = choice.taskId;
      }
    } else {
      if (!!this.question.taskId) {
        _.assignIn(this.model.answer, { taskId: this.question.taskId });
        this.currentSelectedTaskId = this.question.taskId;
      }
    }
  }

  createEmptyAnswer() {
    this.model.answer = {
      questionId: this.question.id,
    };
    this.isValid = false;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form.component.ts